import gql from 'graphql-tag';

import type EntityContext from 'common/constants/entityContexts';
import type Permissions from 'common/constants/permissions';

import { PermissionsFragment } from './fragments';

export const PermissionsQuery = gql`
  query PermissionsQuery($scopes: [PermissionScopeInput!]) {
    permissionScopes: permissions(scopes: $scopes) {
      ...PermissionsFragment
    }
  }
  ${PermissionsFragment}
`;

export interface PermissionScopeInput {
  entityId?: string;
  context?: EntityContext;
  permissionNames?: string[];
}

export interface Permission {
  permissionName: Permissions;
  hasAccess: boolean;
}

export interface PermissionScope {
  entityId?: string | null;
  context?: EntityContext | null;
  permissions: Permission[];
}

export interface PermissionsResponse {
  permissionScopes: PermissionScope[];
}

export interface PermissionsQueryVariables {
  scopes: PermissionScopeInput[];
}
